export default __webpack_public_path__ + "static/media/photo04_sp.99ad3e69.jpg";